import axios from "axios";

export default {
    install: (app, options) => {
        app.config.globalProperties.$saveUserData = $saveUserData;
        app.config.globalProperties.$loadUserData = $loadUserData;
        app.config.globalProperties.$deleteUserData = $deleteUserData;
        app.config.globalProperties.$verifyUserData = $verifyUserData;
        app.config.globalProperties.$refreshTokens = $refreshTokens;
        app.provide('AuthUtil', options);
    }
}

export function $saveUserData(ins,data){
    
    if(data){
        ins.$store.dispatch('createUserData',data);
        if (typeof Storage !== "undefined") {     
            sessionStorage.setItem('userData',JSON.stringify(data));       
        }else{
            alert("Your browser doesn't support functinalities required for this application.");            
        }
    }
    
}

export function $deleteUserData(ins){
    sessionStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    sessionStorage.removeItem('userData');
    ins.$store.dispatch('removeUserData');
}

export function $loadUserData(ins){

    if(ins.$store.state.user&&ins.$store.state.user.userData){
        let data = ins.$store.state.user.userData;
        sessionStorage.setItem('userData',JSON.stringify(data));
        return data;
    }else{    
        let dataFromSession = JSON.parse(sessionStorage.getItem('userData'));
        if(dataFromSession&&dataFromSession.name){
            $saveUserData(ins,dataFromSession);
            return dataFromSession;
        }else{
            //no user information found, clear the user data from vuex store
            ins.$store.dispatch('removeUserData');
            return null;
        }
    }
    
}



export async function $verifyUserData(ins){
        
    if(ins.$store.state.user.userData){
        let accessToken = sessionStorage.getItem("access_token");
        if(accessToken){
            try{
                let profile = await  axios.get(process.env.VUE_APP_API_ROOT+'/user/get-profile',{
                        headers:{
                            'Authorization': 'Bearer '+accessToken
                        }
                    }
                ).then(res => res.data);
                this.$saveUserData(ins,profile);
            }catch(err){
                if(err){            
                    let status = err.response.status;
                    if(401 === status){
                        await this.$refreshTokens(ins);
                    }
                }
            }
        }else{
            await this.$refreshTokens(ins);
        }
    }
    
}

export async function $refreshTokens(ins){

    
    try{

        let refreshToken= localStorage.getItem('refresh_token');

        if(refreshToken){
            let response = await axios.get(process.env.VUE_APP_API_ROOT+'/user/refresh',{
                        headers:{
                            'Authorization': 'Bearer '+refreshToken
                        }
                    }
            ).then(res => res.data);

            let data = response.data;
            let accessToken = data.access_token
            sessionStorage.setItem("access_token",accessToken);
            localStorage.setItem("refresh_token",data.refresh_token);

            let profile = await  axios.get(process.env.VUE_APP_API_ROOT+'/user/get-profile',
                {
                    headers:{
                        'Authorization': 'Bearer '+accessToken
                    }
                }
            ).then(res => res.data);

            this.$saveUserData(ins,profile);
        }else{            
            throw new Error('Error occurred while processing request!');
        }
        
    }catch(err){

        if(err){            
            this.$deleteUserData(ins);
        }

        //route to user login after 1 sec
        let ins2 = ins;
        setTimeout(() => {
            ins2.$router.push({ path: '/login' });
        }, 1000);

        //IMPORTANT:
        //continue to throw error when refresh is failing
        throw err;
    }
}

